(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["custom-header"] && !Shopify.designMode) return;
  try {
    
(function () {
  const panel = document.querySelector('#patient-panel');
  if (!panel) return;

  const root = document.documentElement;
  const body = document.body;

  //  Update panel height (only when needed)
  function updatePanelHeight() {
    const height = Math.round(panel.offsetHeight);
    root.style.setProperty('--patient-panel-height', `${height}px`);
  }

  //  Handle scroll state (adds/removes class)
  function updateScrollState() {
    const isScrolled = window.scrollY > 50;
    body.classList.toggle('is-scrolled', isScrolled);
  }

  //  Initial run
  updatePanelHeight();
  updateScrollState();

  //  Re-measure whenever the panel resizes (covers async content load + viewport resize)
  new ResizeObserver(updatePanelHeight).observe(panel);

  //  Events
  window.addEventListener('scroll', updateScrollState);
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["reorder"] && !Shopify.designMode) return;
  try {
    
  (function () {
    function run() {
      var params = new URLSearchParams(window.location.search);
      var products = params.get('products');
      var wrapper = document.querySelector('[data-reorder-grid-wrapper]');
      var grid = wrapper ? wrapper.querySelector('.product-grid--reorder') : null;
      var loadingEl = document.querySelector('[data-reorder-loading]');
      var unavailableEl = document.querySelector('[data-reorder-unavailable]');
      var errorEl = document.querySelector('[data-reorder-error]');

      function hideLoading() {
        if (loadingEl) loadingEl.style.display = 'none';
      }

      function showUnavailable() {
        hideLoading();
        if (unavailableEl) unavailableEl.style.display = '';
      }

      function showError() {
        hideLoading();
        if (errorEl) errorEl.style.display = '';
      }

      if (!products) {
        showUnavailable();
        return;
      }

      var handles = products.split(',').map(function (h) { return h.trim(); }).filter(Boolean);

      if (handles.length === 0) {
        showUnavailable();
        return;
      }

      var coverageScriptSrc = null;
      var coverageScriptLoaded = false;
      var coverageScriptPromise = null;

      function rememberCoverageScriptSrc(root) {
        if (coverageScriptSrc || !root) return;
        var coverageScript = root.querySelector('script[src*="rsm-product-coverage"]');
        if (coverageScript) coverageScriptSrc = coverageScript.src;
      }

      function stripCoverageScripts(root) {
        if (!root) return;
        root.querySelectorAll('script[src*="rsm-product-coverage"]').forEach(function (script) {
          script.remove();
        });
      }

      function activateScripts(root) {
        root.querySelectorAll('script').forEach(function (script) {
          var replacement = document.createElement('script');
          Array.from(script.attributes).forEach(function (attr) {
            replacement.setAttribute(attr.name, attr.value);
          });
          replacement.textContent = script.textContent;
          script.replaceWith(replacement);
        });
      }

      function loadCoverageApp() {
        if (coverageScriptLoaded) return Promise.resolve();
        if (coverageScriptPromise) return coverageScriptPromise;
        if (!coverageScriptSrc) return Promise.resolve();
        if (!document.getElementById('product-coverage-indicators')) return Promise.resolve();

        coverageScriptPromise = new Promise(function (resolve) {
          var script = document.createElement('script');
          script.type = 'module';
          script.src = coverageScriptSrc;
          script.onload = function () {
            coverageScriptLoaded = true;
            resolve();
          };
          script.onerror = resolve;
          document.head.appendChild(script);
        });

        return coverageScriptPromise;
      }

      function fetchReorderCard(handle) {
        // Section Rendering API omits app blocks; fetch the alternate template HTML instead.
        return fetch('/products/' + handle + '?view=reorder-card')
          .then(function (res) {
            if (!res.ok) return null;
            return res.text();
          })
          .then(function (html) {
            if (!html) return null;
            var doc = new DOMParser().parseFromString(html, 'text/html');
            var card = doc.querySelector('custom-product-card.cpc_wrapper');
            if (!card) return null;
            rememberCoverageScriptSrc(card);
            stripCoverageScripts(card);
            return card.outerHTML;
          })
          .catch(function () { return null; });
      }

      Promise.all(handles.map(fetchReorderCard)).then(function (results) {
        hideLoading();

        var succeeded = 0;
        results.forEach(function (html) {
          if (!html || !grid) return;
          var li = document.createElement('li');
          li.className = 'product-grid__item';
          li.innerHTML = html;
          activateScripts(li);
          grid.appendChild(li);
          succeeded++;
        });

        if (succeeded === 0) {
          showUnavailable();
        } else {
          if (wrapper) wrapper.style.display = '';
          loadCoverageApp();
        }
      }).catch(function () {
        showError();
      });
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', run);
    } else {
      run();
    }
  }());

  } catch(e) { console.error(e); }
})();
})();
